import script from "./ContatosHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ContatosHome.vue?vue&type=script&setup=true&lang=js"

import "./ContatosHome.vue?vue&type=style&index=0&id=0dd3048a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd3048a"]])

export default __exports__